import { office } from './office';
import { workstation } from './workstation';
import { mobilitystation } from './mobilitystation';
import { opencollaboration } from './opencollaboration';
import { closedcollaboration } from './closedcollaboration';
import { reception } from './reception';
import { serviceareas } from './serviceareas';
import { pantry } from './pantry';
import { filingcabinets } from './filingcabinets';
import { specific } from './specific';

export const spaces = [
  ...office,
  ...workstation,
  ...mobilitystation,
  ...opencollaboration,
  ...closedcollaboration,
  ...reception,
  ...serviceareas,
  ...pantry,
  ...filingcabinets,
  ...specific,
];
